import {createSelector} from 'reselect';

const getShoppingCart = (store) => store.shoppingCart.shoppingCart || {};
const getAccommodationInfo = (shoppingCart) => shoppingCart.accommodationShoppingItem;

const accommodationInfoSelector = createSelector(getShoppingCart, getAccommodationInfo);

export default {
    accommodationInfo: (store) => accommodationInfoSelector(store),
};
